import { render, staticRenderFns } from "./galeria_articulo.vue?vue&type=template&id=ca60b820&"
import script from "./galeria_articulo.vue?vue&type=script&lang=js&"
export * from "./galeria_articulo.vue?vue&type=script&lang=js&"
import style0 from "./galeria_articulo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports